import React from 'react';
const CHECKOUT_URL = 'https://betterdailyguides.com/cart/51925795668270:1';
interface HeroSectionProps {
  onBuyClick: (e: React.MouseEvent) => void;
}
export function HeroSection({
  onBuyClick
}: HeroSectionProps) {
  return <section aria-label="Introducción al Protocolo B.E.BE 365" className="bg-gradient-to-br from-[#FAF7F2] via-[#F0E8DE] to-[#E8DDD0] min-h-screen flex items-center py-10 md:py-24 px-5 relative overflow-hidden" data-id="element-198">
      {/* Soft background wash */}
      <div className="absolute inset-0 z-0" aria-hidden="true" data-id="element-199">
        <div className="w-full h-full bg-gradient-to-br from-[#F0E4D8] via-[#E8D9CC] to-[#DFD0C2] opacity-40" data-id="element-200" />
        <div className="absolute inset-0 bg-gradient-to-br from-[#FAF7F2]/70 via-[#F0E8DE]/60 to-[#E8DDD0]/70" data-id="element-201" />
      </div>

      <div className="absolute top-[-50%] right-[-20%] w-[600px] h-[600px] rounded-full bg-gradient-radial from-[rgba(183,110,121,0.08)] to-transparent pointer-events-none z-[1]" aria-hidden="true" data-id="element-202" />

      <div className="max-w-[1100px] mx-auto flex flex-col md:grid md:grid-cols-2 md:gap-16 md:items-center w-full relative z-[2]" data-id="element-203">
        {/* Top content: badge + h1 + paragraph + mobile CTA */}
        <div className="order-1 md:order-1 text-center md:text-left md:col-span-1 md:row-span-1" data-id="element-204">
          <span className="inline-block bg-gradient-to-r from-[#B76E79] to-[#8B4A52] text-white text-xs tracking-widest uppercase px-4 py-1.5 rounded-full mb-5 font-sans font-bold" data-id="element-205">
            ⭐ Protocolo B.E.BE 365 — Edición 2026
          </span>

          <h1 className="text-[32px] md:text-5xl lg:text-6xl text-[#3D2B1F] leading-[1.1] md:leading-tight mb-4 font-bold font-serif" data-id="element-206">
            Por fin: Un Sistema Completo Para Que Dejes De{' '}
            <span className="text-[#B76E79]" data-id="element-207">Sobrevivir</span> El Primer Año Y
            Comiences A Disfrutarlo.
          </h1>

          {/* Mobile-only image below */}
          <div className="block md:hidden mb-5" data-id="element-208">
            <div className="rounded-[25px] overflow-hidden shadow-2xl max-w-[400px] mx-auto" data-id="element-209">
              <img src="https://cdn.shopify.com/s/files/1/0981/0781/8286/files/Maternidad_en_la_luz_suave.png?v=1775496895" alt="B.E.BE 365 Protocol" width="400" height="400" loading="eager" fetchPriority="high" decoding="async" className="w-full h-auto block" data-id="element-210" />
            </div>
          </div>

          <p className="text-sm md:text-xl text-[#888] md:text-[#6B4C3B] mb-6 leading-relaxed italic max-w-[300px] md:max-w-none mx-auto md:mx-0" data-id="element-211">
            El primer protocolo de neuro-arquitectura infantil que unifica
            sueño, nutrición y estímulo cognitivo.
          </p>

          {/* Mobile-only CTA after paragraph */}
          <a href={CHECKOUT_URL} onClick={onBuyClick} className="block md:hidden w-full bg-gradient-to-r from-[#B76E79] to-[#8B4A52] text-white text-lg font-bold py-4 px-8 rounded-full text-center tracking-wide shadow-lg hover:shadow-xl transition-all hover:-translate-y-1 font-sans uppercase mb-3 animate-cta-pulse" data-id="element-212">
            ⚡ OBTENER EL PROTOCOLO — $6.39 →
          </a>

          {/* Mobile-only: immediate access text */}
          <p className="md:hidden text-center text-sm tracking-widest uppercase text-[#B76E79] font-sans font-bold mb-6" data-id="element-213">
            📥 ACCESO INMEDIATO — PAGO ÚNICO
          </p>

          {/* Desktop-only: checklist, price box, CTA, badges */}
          <div className="hidden md:block" data-id="element-214">
            <ul className="list-none mb-9 space-y-3.5 text-left" data-id="element-215">
              {['Tu bebé durmiendo 8 horas en tiempo récord', '52 actividades científicas para disparar su coeficiente intelectual', 'La guía nutricional que elimina los problemas con la comida para siempre', 'Acceso inmediato + 4 Bonos valorados en $138'].map((item, idx) => <li key={idx} className="flex items-start gap-3 text-base text-[#3D2B1F] font-sans" data-id="element-216">
                  <span className="flex items-center justify-center w-5 h-5 rounded-full bg-[#B76E79] text-white text-xs font-bold flex-shrink-0 mt-0.5" data-id="element-217">
                    ✓
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="bg-white rounded-2xl p-6 shadow-lg border-2 border-[rgba(183,110,121,0.2)] mb-6" data-id="element-218">
              <div className="text-sm tracking-widest uppercase text-[#B76E79] font-sans font-bold mb-2" data-id="element-219">
                🔒 Descarga Digital Inmediata
              </div>
              <div className="text-lg text-gray-400 line-through font-sans mb-1" data-id="element-220">
                Valor total: $147
              </div>
              <div className="text-5xl md:text-6xl text-[#3D2B1F] font-bold leading-none mb-1.5" data-id="element-221">
                $6.39
              </div>
              <span className="inline-block bg-green-50 text-green-700 text-sm font-bold px-3 py-1 rounded-full font-sans" data-id="element-222">
                💰 Ahorras $140.61 hoy (96% OFF)
              </span>
              <p className="mt-3 text-sm text-[#6B4C3B] font-sans italic leading-relaxed" data-id="element-223">
                ¿Por qué solo $6.39? Porque es un producto digital y no tenemos
                costos de impresión ni envío. Te pasamos esos ahorros a ti.
              </p>
            </div>

            <a href={CHECKOUT_URL} onClick={onBuyClick} className="block w-full bg-gradient-to-r from-[#B76E79] to-[#8B4A52] text-white text-lg font-bold py-4 px-8 rounded-full text-center tracking-wide shadow-lg hover:shadow-xl transition-all hover:-translate-y-1 font-sans uppercase mb-3 animate-cta-pulse" data-id="element-224">
              ⚡ SÍ, QUIERO ACCESO INMEDIATO POR $6.39 →
            </a>

            <div className="flex gap-5 flex-wrap text-sm text-gray-400 font-sans justify-start" data-id="element-225">
              <span className="flex items-center gap-1.5" data-id="element-226">
                🔒 Pago 100% Seguro
              </span>
              <span className="flex items-center gap-1.5" data-id="element-227">
                🚫 Sin Suscripciones Ocultas
              </span>
              <span className="flex items-center gap-1.5" data-id="element-228">
                📥 Descarga Inmediata
              </span>
              <span className="flex items-center gap-1.5" data-id="element-229">
                ↩️ Garantía de 30 Días
              </span>
              <span className="flex items-center gap-1.5" data-id="element-230">
                💳 Visa · PayPal · Mastercard
              </span>
            </div>
          </div>
        </div>

        {/* Image - hidden on mobile, right side on desktop */}
        <div className="relative order-2 md:order-2 hidden md:flex flex-col gap-8 mb-8 md:mb-0" data-id="element-231">
          <div className="relative" data-id="element-232">
            <div className="rounded-3xl overflow-hidden shadow-2xl" style={{
            aspectRatio: '3/2'
          }} data-id="element-233">
              <img src="https://cdn.shopify.com/s/files/1/0981/0781/8286/files/Maternidad_en_la_luz_suave.png?v=1775496895" alt="Madre y bebé — Protocolo B.E.BE 365" width="600" height="400" loading="eager" fetchPriority="high" decoding="sync" className="w-full h-full object-cover" data-id="element-234" />
            </div>
            <div className="hidden md:block absolute bottom-[-15px] left-[-15px] bg-white rounded-xl p-3 shadow-xl font-sans text-center border-l-4 border-[#B76E79]" data-id="element-235">
              <strong className="block text-2xl text-[#B76E79]" data-id="element-236">+2,400</strong>
              <span className="text-xs text-gray-400" data-id="element-237">
                Familias ya lo aplican
              </span>
            </div>
          </div>
        </div>

        {/* Mobile-only: checklist after image */}
        <div className="order-3 md:hidden text-center" data-id="element-238">
          <ul className="list-none mb-4 space-y-3.5 text-left" data-id="element-239">
            {['Tu bebé durmiendo 8 horas en tiempo récord', '52 actividades científicas para disparar su coeficiente intelectual', 'La guía nutricional que elimina los problemas con la comida para siempre', 'Acceso inmediato + 4 Bonos valorados en $138'].map((item, idx) => <li key={idx} className="flex items-start gap-3 text-base text-[#3D2B1F] font-sans" data-id="element-240">
                <span className="flex items-center justify-center w-5 h-5 rounded-full bg-[#B76E79] text-white text-xs font-bold flex-shrink-0 mt-0.5" data-id="element-241">
                  ✓
                </span>
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}